import { jsx as e, jsxs as x } from "react/jsx-runtime";
import { createElement as c } from "react";
import { Box as h } from "@mui/material";
import "../../queries/message/index.js";
import "../../queries/contact/index.js";
import "../../queries/calendars/index.js";
import { N as i, A as y } from "../../pointsGraph-DTJju-rA.js";
import "../../queries/student/index.js";
import "../../queries/settings/index.js";
import "../../queries/points/index.js";
import { assessment as I } from "../../queries/assessment/index.js";
import "../../queries/assessment/annotations/index.js";
import "../../queries/assessment/rubrics/index.js";
import "../../queries/assessment/qcesubjects/index.js";
import "../../queries/assessment/extensionrequest/index.js";
import "../../queries/files/index.js";
import "../../queries/attendance/index.js";
import "../../queries/forms/index.js";
import "../../queries/notifications/index.js";
import "../../queries/interviews/index.js";
import "../../queries/notes/index.js";
import "../../queries/annoucements/index.js";
import "../../queries/payments/index.js";
import "../../queries/assessment/analysis/index.js";
import "../../queries/group/index.js";
import "../../queries/projects/index.js";
import "../../queries/courses/index.js";
import "../../queries/password/index.js";
import { DaymapSkeleton as A } from "../skeletons/index.js";
const Z = ({
  studentId: p,
  classCode: n,
  selectedDateRange: a,
  onlyPublishedResults: l,
  onTaskClick: o,
  courseId: d,
  overdueOnly: f = !1,
  loadPreview: u = !1
}) => {
  const { isPending: g, error: t, data: s } = new I.TasksForStudent({
    studentId: Number(p),
    dateRange: a,
    allPublished: l,
    classCode: n,
    courseId: d,
    loadPreview: u
  }).ToQuery();
  t && console.error("Error getting tasks for student", t);
  const m = f ? (s || []).filter((r) => r.Overdue) : s || [];
  return /* @__PURE__ */ e(h, { sx: { display: "flex", flexFlow: "column", gap: 1 }, children: g ? /* @__PURE__ */ e(A, { type: "listitems" }) : t ? /* @__PURE__ */ x(i, { children: [
    "Error loading tasks: ",
    t.title
  ] }) : m.length === 0 ? /* @__PURE__ */ e(i, { children: "No Assessment Tasks" }) : m.map((r) => /* @__PURE__ */ c(y, { ...r, key: r.ID, onClick: () => o == null ? void 0 : o(r.ID) })) });
};
export {
  Z as AssessmentTaskList
};
//# sourceMappingURL=AssessmentTaskList.js.map
